/*
 * hellopanda-scrollto
 */
const HELLOPANDA_SCROLLTO = {
  init: function() {
    const _ = this;
    document.addEventListener('DOMContentLoaded', function() {

      _.add_url_scrollto();
      _.add_event_scrollto();

    });
  },
  add_url_scrollto: function() {
    const _ = this;

    const url = new URL(window.location);
    const hash = url.hash.substring(1);
    if (hash) {
      const target = document.querySelector(`.wp-block-hellopanda-scrollto-block[data-id="${hash}"]`);
      if (target) {
        const scrollGap = parseFloat(target.dataset.gap || 0) || 0;
        const scrollSpeed = parseFloat(target.dataset.speed || 0) || 0;
        _.go_to_scroll(target, scrollGap, scrollSpeed);
      }
    }

  },
  add_event_scrollto: function() {
    const _ = this;

    const scrollToArray = document.querySelectorAll('.wp-block-hellopanda-scrollto-block');
    scrollToArray.forEach(scrollToElement => {
      const scrollId = scrollToElement.dataset.id;
      const scrollGap = parseFloat(scrollToElement.dataset.gap || 0) || 0;
      const scrollSpeed = parseFloat(scrollToElement.dataset.speed || 0) || 0;
      const scrollHash = scrollToElement.dataset.hash || '';
      console.log(scrollId, 'scrollId')
      if (scrollId) {
        const buttons = document.querySelectorAll(`[href="#${scrollId}"], [data-link-url="#${scrollId}"]`);
        buttons.forEach(button => {
          button.addEventListener('click', function (e) {
            if (scrollHash === 'false') {
              e.preventDefault();
            }
            _.go_to_scroll(scrollToElement, scrollGap, scrollSpeed);
          });
        });
      }
    });

  },
  go_to_scroll: function(scrollToElement, scrollGap, scrollSpeed) {
    const _ = this;

    let animationFrameId = null;

    const targetY = scrollToElement.getBoundingClientRect().top + window.pageYOffset - scrollGap;
  
    if (!scrollSpeed || scrollSpeed <= 0) {
      window.scrollTo(0, targetY);
      return;
    }
  
    const startY = window.pageYOffset;
    const distance = targetY - startY;
    const duration = scrollSpeed * 1000;
    const startTime = performance.now();
  
    const easing = t => t < 0.5
      ? 4 * t * t * t
      : 1 - Math.pow(-2 * t + 2, 3) / 2;
  
    const cancelOnUserScroll = () => {
      if (animationFrameId) {
        cancelAnimationFrame(animationFrameId);
        animationFrameId = null;
        removeListeners();
      }
    };
  
    const addListeners = () => {
      ['wheel', 'touchstart', 'keydown', 'mousedown'].forEach(type =>
        window.addEventListener(type, cancelOnUserScroll, { passive: true, once: true })
      );
    };
  
    const removeListeners = () => {
      ['wheel', 'touchstart', 'keydown', 'mousedown'].forEach(type =>
        window.removeEventListener(type, cancelOnUserScroll)
      );
    };
  
    function animate(currentTime) {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);
      const easedProgress = easing(progress);
  
      window.scrollTo(0, startY + distance * easedProgress);
  
      if (progress < 1) {
        animationFrameId = requestAnimationFrame(animate);
      } else {
        animationFrameId = null;
        removeListeners();
      }
    }
  
    addListeners();
    animationFrameId = requestAnimationFrame(animate);

  }
};
HELLOPANDA_SCROLLTO.init();